import { BaseNode, type NodeConfig } from 'mflows';

// 数组输入节点配置类型
interface ArrayInputConfig extends NodeConfig {
  value?: any[];
}

// 表单输入节点配置类型
interface FormInputConfig extends NodeConfig {
  type?: string;
  [key: string]: any;
}

// JSON输入节点配置类型
interface JsonInputConfig extends NodeConfig {
  value?: object;
}

// 数组输入节点类
export class ArrayInput extends BaseNode<ArrayInputConfig, any[]> {
  static NodeType = '数组输入';

  protected async initialize(): Promise<void> {
    this.setOutputPorts([
      { id: 'array-data', dataType: 'array', name: '数据:array' }

    ]);
    
    // 初始化时触发一次输出
    if (this.settings.value) {
      this.emitData();
    }
  }

  protected receiveData(pointId: string, data: unknown): void {
    void pointId; void data;
    // arrayInput 接收数据
    console.log('arrayInput接收数据', pointId, data);
  }

  protected checkConfig(): boolean {
    return Array.isArray(this.settings.value);
  }

  protected async processConfigUpdate(changes: Partial<ArrayInputConfig>): Promise<any[]> {
    if (changes.value && Array.isArray(changes.value)) {
      this.settings.value = changes.value;
      this.emitData();
      return changes.value;
    }
    return this.settings.value || [];
  }

  private emitData(): void {
    this.setDataChange(this.settings.value || []);
  }
}

// 表单输入节点类
export class FormInput extends BaseNode<FormInputConfig, unknown> {
  static NodeType = '表单输入';
  
  protected async initialize(): Promise<void> {
    this.setOutputPorts([
      { id: 'form-data', dataType: 'any', name: '数据' }
    ]);
    this.changeOutputType('form-data', `form-${this.settings?.type || 'text'}`);
    
    // 初始化时触发一次输出
    if (this.settings.value !== undefined) {
      this.emitData();
    }
  }
  
  protected receiveData(pointId: string, data: unknown): void {
    void pointId; void data;
    // formInput 接收数据
    console.log('formInput接收数据', pointId, data);
  }
  
  protected checkConfig(): boolean {
    return !!this.settings.type;
  }
  
  protected async processConfigUpdate(changes: Partial<FormInputConfig>): Promise<unknown> {
    if (changes.type) {
      this.settings.type = changes.type;
      this.changeOutputType('form-data', `form-${changes.type}`);
    }
    if (changes.value !== undefined) {
      this.settings.value = changes.value;
      this.emitData();
    }
    return this.settings.value;
  }
  
  private changeOutputType(id: string, dataType: string) {
    this.outputPorts.forEach(point => {
      if (point.id === id) {
        point.dataType = dataType;
        point.name = `数据:${dataType}`;

      }
    });
  }

  private emitData(): void {
    this.setDataChange(this.settings.value);
  }
}

// JSON输入节点类
export class JsonInput extends BaseNode<JsonInputConfig, object> {
  static NodeType = 'JSON输入';

  protected async initialize(): Promise<void> {
    this.setOutputPorts([
      { id: 'json-data', dataType: 'object', name: '数据:json' }
    ]);
    
    // 初始化时触发一次输出
    if (this.settings.value) {
      this.emitData();
    }
  }

  protected receiveData(pointId: string, data: unknown): void {
    void pointId; void data;
    // jsonInput 接收数据
    console.log('jsonInput接收数据', pointId, data);
  }

  protected checkConfig(): boolean {
    return typeof this.settings.value === 'object' && this.settings.value !== null;
  }

  protected async processConfigUpdate(changes: Partial<JsonInputConfig>): Promise<object> {
    if (changes.value && typeof changes.value === 'object') {
      this.settings.value = changes.value;
      this.emitData();
      return changes.value;
    }
    return this.settings.value || {};
  }

  private emitData(): void {
    this.setDataChange(this.settings.value || {});
  }
}